/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_IntroInputs */



/**
* | output |
* | --- |
* | "oneAI is not liable for damages arising from:" |
*
* @param {Guardrails_Section_4_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_intro = /** @type {((inputs?: Guardrails_Section_4_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI haftet nicht für Schäden, die entstehen durch:")
	return /** @type {LocalizedString} */ ("oneAI is not liable for damages arising from:")
});